import React from 'react';

import CommonSettings from '../Drive/CommonSettings'

export default class SettingList extends React.Component {
    render() {
        return (
            <div className="general-setting" >
                <CommonSettings {...this.props} /><br />
            </div>
        );
    }
}
